import {Component, ContentChild, OnInit, TemplateRef} from "@angular/core";
import {DxUserInfoDirective} from "../../directives/user-bar/dx-user-info.directive";
import {DxSessionService} from "../../../services/dx-session.service";
import {DxUserSession} from "../../../domain/user/dx-user-session";
import {Observable} from "rxjs";


@Component({
  selector: 'dx-user-bar',
  templateUrl: './dx-user-bar.component.html',
  styleUrls: ['./dx-user-bar.component.css']
})
export class DxUserBarComponent implements OnInit {
  @ContentChild(DxUserInfoDirective, {static: true, read: TemplateRef})
  public userInfoTemplate: DxUserInfoDirective;

  session: DxUserSession;

  constructor(private _sessionService: DxSessionService) {}

  ngOnInit(): void {
    this.session = this._sessionService.currentSession;
  }
}
